export const templateCertificadoParagrafoInicial = {
  texto: `Certificado nº {numeroCertificado} referente ao processo
  nº {processoAdministrativo} emitido em {dataEmissao},
  no município de {municipioEmissao}/{ufEmissao}.

  `
}

export const templateCertificadoPF = {
  texto: `A Secretaria de Desenvolvimento Agropecuário e da Pesca – SEDAP,
  na qualidade de outorgante, certifica para os devidos fins {nomeTitular},
  nascida(o) em {dataNascimento}, de CPF {cpfTitular}, natural de
  {municipioNaturalidade}/{ufNaturalidade}, de estado civil {estadoCivil}
  {conjugeInfo}, proprietário(a) do imóvel {nomeImovel} que se localiza
  no município de {municipioImovel}/{ufImovel}, com endereço CEP {cepImovel},
  {localidadeImovel}, {logradouroImovel},
  e número(s) de Cadastro Ambiental Rural (CAR): {numeroCAR}.`
}

export const templateCertificadoPJ = {
  texto: `A Secretaria de Desenvolvimento Agropecuário e da Pesca – SEDAP,
  na qualidade de outorgante, certifica para os devidos fins {nomeTitular},
  {nomeFantasia}, com CNPJ {cpfTitular} e inscrição estadual {inscricaoEstadual},
  localizada em {municipioPJ}/{ufPJ}, proprietário(a) do imóvel {nomeImovel}
  localizado no município de {municipioImovel}/{ufImovel}, com endereço: CEP {cepImovel}, {logradouroImovel}, {localidadeImovel},
  e número(s) de Cadastro Ambiental Rural (CAR): {numeroCAR}.`
}

export function gerarTextoCertificado (dados) {
  const {
    titular = {},
    imovel = {}
  } = dados
  const pessoa = titular?.pessoa || {}
  const pessoaFisica = pessoa?.pessoaFisica || {}
  const pessoaJuridica = pessoa?.pessoaJuridica || {}
  const conjuge = titular?.conjuge?.pessoaFisica || {}

  const isPessoaFisica = pessoa.tipo === 'PF'

  let nomeTitular = '-'
  let cpfCnpj = '-'
  let dataNascimento = '-'
  let estadoCivil = '-'
  let conjugeInfo = ''

  let municipioNaturalidadeUF = `${(pessoaFisica.naturalidade?.nome || '-').trim()}/${(pessoaFisica.naturalidade?.codigoEstado || '-').trim()}`
  let municipioImovelUF = `${(imovel.endereco?.municipio?.nome || '-').trim()}/${(imovel.endereco?.municipio?.codigoEstado || '-').trim()}`
  let municipioPJUF = `${(dados.titular?.pessoa?.enderecoCorrespondencia?.municipio?.nome || '-').trim()}/${(dados.titular?.pessoa?.enderecoCorrespondencia?.municipio?.codigoEstado || '-').trim()}`

  if (isPessoaFisica) {
    nomeTitular = pessoaFisica.nome || '-'
    cpfCnpj = pessoaFisica.cpf || '-'
    dataNascimento = pessoaFisica.dataNascimento
      ? new Date(pessoaFisica.dataNascimento).toLocaleDateString('pt-BR')
      : '-'
    estadoCivil = pessoaFisica.estadoCivil || '-'

    if (estadoCivil === 'CASADO' || estadoCivil === 'UNIAO_ESTAVEL') {
      if (conjuge.nome && conjuge.cpf) {
        conjugeInfo = ` com <strong>${conjuge.nome}</strong> de CPF <strong>${conjuge.cpf}</strong>`
      }
    }
  }

  let logradouroFormatado = '-'
  if (imovel.endereco?.logradouro && imovel.endereco.logradouro.trim()) {
    logradouroFormatado = imovel.endereco.logradouro
    if (imovel.endereco.numero && !imovel.endereco.semNumero) {
      logradouroFormatado += `, ${imovel.endereco.numero}`
    }
  } else if (imovel.endereco?.numero && !imovel.endereco.semNumero) {
    logradouroFormatado = `Nº ${imovel.endereco.numero}`
  }
  let numeroCAR = '-'
  if (imovel.numerosRecibosCar && imovel.numerosRecibosCar.length > 0) {
    numeroCAR = imovel.numerosRecibosCar.map(car => {
      if (typeof car === 'string') {
        return car
      } else if (car && typeof car === 'object' && car.numero) {
        return car.numero
      }
      return String(car)
    }).join(', ')
  } else {
    numeroCAR = 'não informado'
  }

  let texto = ''
  if (isPessoaFisica) {
    texto = templateCertificadoPF.texto
      .replace('{nomeTitular}', `<strong>${nomeTitular}</strong>`)
      .replace('{dataNascimento}', `<strong>${dataNascimento}</strong>`)
      .replace('{cpfTitular}', `<strong>${cpfCnpj}</strong>`)
      .replace('{municipioNaturalidade}/{ufNaturalidade}', `<strong>${municipioNaturalidadeUF}</strong>`)
      .replace('{estadoCivil}', `<strong>${estadoCivil}</strong>`)
      .replace('{conjugeInfo}', conjugeInfo)
      .replace('{nomeImovel}', `<strong>${imovel.nome || '-'}</strong>`)
      .replace('{municipioImovel}/{ufImovel}', `<strong>${municipioImovelUF}</strong>`)
      .replace('{cepImovel}', `<strong>${imovel.endereco?.cep || '-'}</strong>`)
      .replace('{localidadeImovel}', `<strong>${imovel.endereco?.comunidadeLocalidade || '-'}</strong>`)
      .replace('{logradouroImovel}', `<strong>${logradouroFormatado}</strong>`)
      .replace('{numeroCAR}', `<strong>${numeroCAR}</strong>`)
  } else {
    texto = templateCertificadoPJ.texto
      .replace('{nomeTitular}', `<strong>${pessoaJuridica.razaoSocial || '-'}</strong>`)
      .replace('{nomeFantasia}', `<strong>${pessoaJuridica.nomeFantasia || '-'}</strong>`)
      .replace('{cpfTitular}', `<strong>${pessoaJuridica.cnpj || '-'}</strong>`)
      .replace('{inscricaoEstadual}', `<strong>${pessoaJuridica.inscricaoEstadual || '-'}</strong>`)
      .replace('{municipioPJ}/{ufPJ}', `<strong>${municipioPJUF}</strong>`)
      .replace('{nomeImovel}', `<strong>${imovel.nome || '-'}</strong>`)
      .replace('{municipioImovel}/{ufImovel}', `<strong>${municipioImovelUF}</strong>`)
      .replace('{cepImovel}', `<strong>${imovel.endereco?.cep || '-'}</strong>`)
      .replace('{localidadeImovel}', `<strong>${imovel.endereco?.comunidadeLocalidade || '-'}</strong>`)
      .replace('{logradouroImovel}', `<strong>${logradouroFormatado}</strong>`)
      .replace('{numeroCAR}', `<strong>${numeroCAR}</strong>`)
  }

  return texto
}

export const formatPrimeiroParagrafo = (texto, caracteristicas) => {
  const municipioEmissaoUF = 'Belém/PA'

  let dataEmissao = '-'
  if (caracteristicas.dataEmissao) {
    try {
      if (typeof caracteristicas.dataEmissao === 'string' && caracteristicas.dataEmissao.includes('-')) {
        const [ano, mes, dia] = caracteristicas.dataEmissao.split('-')
        const data = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
        dataEmissao = data.toLocaleDateString('pt-BR')
      } else {
        dataEmissao = new Date(caracteristicas.dataEmissao).toLocaleDateString('pt-BR')
      }
    } catch (error) {
      console.warn('Erro ao formatar data de emissão:', error)
      dataEmissao = caracteristicas.dataEmissao || '-'
    }
  }

  return texto
    .replace('{numeroCertificado}', `<strong>${caracteristicas.numeroCertificado || '-'}</strong>`)
    .replace('{processoAdministrativo}', `<strong>${caracteristicas.numeroProcesso || '-'}</strong>`)
    .replace('{dataEmissao}', `<strong>${dataEmissao}</strong>`)
    .replace('{municipioEmissao}/{ufEmissao}', `<strong>${municipioEmissaoUF}</strong>`)
}



// WEBPACK FOOTER //
// ./src/constants/certificacao.js